// Dados estruturados para a organização
export const getOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Arena Pro Player Academy",
  "alternateName": "Arena Pro Player",
  "url": "https://arena-pro-player.com",
  "logo": "https://arena-pro-player.com/arena-logo.png",
  "description": "Plataforma líder em mentorias para gamers profissionais. Conectamos jogadores com mentores experientes para acelerar seu crescimento no mundo dos esports.",
  "foundingDate": "2024",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+55-11-94300-6646",
    "contactType": "customer service",
    "availableLanguage": "Portuguese"
  },
  "sameAs": [
    "https://www.instagram.com/arena.proplayer",
    "https://www.tiktok.com/@arena.pro.player",
    "https://youtube.com/@arenaproplayer"
  ],
  "serviceArea": {
    "@type": "Country",
    "name": "Brazil"
  }
});

// Dados estruturados para mentor
export const getMentorSchema = (mentor: any) => ({
  "@context": "https://schema.org",
  "@type": "Person",
  "name": mentor.name,
  "jobTitle": `Coach Profissional de ${mentor.games?.map((g: any) => g.name).join(', ')}`,
  "description": mentor.bio,
  "image": mentor.image_url,
  "url": `https://arena-pro-player.com/mentores/${mentor.slug || mentor.id}`,
  "worksFor": {
    "@type": "Organization",
    "name": "Arena Pro Player Academy"
  },
  "aggregateRating": mentor.average_rating > 0 ? {
    "@type": "AggregateRating",
    "ratingValue": mentor.average_rating,
    "ratingCount": mentor.total_reviews || 1,
    "bestRating": 5,
    "worstRating": 1
  } : undefined,
  "offers": mentor.offerings?.map((offering: any) => ({
    "@type": "Offer",
    "name": offering.title,
    "description": offering.description,
    "price": (offering.price_cents / 100).toFixed(2),
    "priceCurrency": "BRL",
    "availability": "https://schema.org/InStock"
  })) || [],
  "sameAs": [
    mentor.social?.youtube,
    mentor.social?.twitch,
    mentor.social?.instagram
  ].filter(Boolean)
});

// Dados estruturados para curso/mentoria
export const getCourseSchema = (offering: any, mentor: any) => ({
  "@context": "https://schema.org",
  "@type": "Course",
  "name": offering.title,
  "description": offering.description,
  "provider": {
    "@type": "Organization",
    "name": "Arena Pro Player Academy",
    "url": "https://arena-pro-player.com"
  },
  "instructor": {
    "@type": "Person",
    "name": mentor.name,
    "image": mentor.image_url
  },
  "offers": {
    "@type": "Offer",
    "price": (offering.price_cents / 100).toFixed(2),
    "priceCurrency": "BRL",
    "availability": "https://schema.org/InStock"
  },
  "courseMode": offering.is_group ? "group" : "individual",
  "timeRequired": `PT${offering.duration_minutes}M`,
  "inLanguage": "pt-BR",
  "about": offering.game?.name
});

// Dados estruturados para jogo
export const getGameSchema = (game: any, mentorCount: number) => ({
  "@context": "https://schema.org",
  "@type": "VideoGame",
  "name": game.name,
  "image": game.cover_url,
  "description": `Encontre mentores profissionais para ${game.name}. ${mentorCount} mentores disponíveis na Arena Pro Player Academy.`,
  "genre": "Esports",
  "gamePlatform": "PC",
  "offers": {
    "@type": "AggregateOffer",
    "offerCount": mentorCount,
    "lowPrice": "25.00",
    "highPrice": "200.00",
    "priceCurrency": "BRL"
  }
});

// Dados estruturados para página inicial
export const getWebsiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Arena Pro Player Academy",
  "alternateName": "Arena Pro Player",
  "url": "https://arena-pro-player.com",
  "description": "Plataforma líder em mentorias para gamers profissionais. Conectamos jogadores com mentores experientes para acelerar seu crescimento no mundo dos esports.",
  "inLanguage": "pt-BR",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://arena-pro-player.com/mentores?search={search_term_string}",
    "query-input": "required name=search_term_string"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Arena Pro Player Academy",
    "logo": "https://arena-pro-player.com/arena-logo.png"
  }
});

// Dados estruturados para breadcrumbs
export const getBreadcrumbSchema = (items: Array<{name: string, url: string}>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

// Dados estruturados para FAQ
export const getFAQSchema = (faqs: Array<{question: string, answer: string}>) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

// Dados estruturados para HowTo
export const getHowToSchema = (title: string, description: string, steps: Array<{name: string, text: string}>) => ({
  "@context": "https://schema.org",
  "@type": "HowTo",
  "name": title,
  "description": description,
  "step": steps.map((step, index) => ({
    "@type": "HowToStep",
    "position": index + 1,
    "name": step.name,
    "text": step.text
  }))
}); 